import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/door/devicearea/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/door/devicearea/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/door/devicearea/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/door/devicearea/submit', params, options);

export const update = (params, options) =>
  request.post('/api/door/devicearea/submit', params, options);

//根据小区id查询门禁信息
export const getDoorInfoByCommunityId = (communityId) => {
  return request({
    url: '/api/door/baseinfo/getDoorInfoByCommunityId',
    method: 'get',
    params: {
      communityId,
    },
  });
};

export const getBasePropertyTree = (communityId) => {
  return request({
    url: '/api/base/property/getBasePropertyTree',
    method: 'get',
    params: {
      communityId,
    },
  });
};

export const auth = (params, options) => request.post('/api/door/deviceauth/auth', params, options);

export const getAuthInfo = (params, options) =>
  request.get('/api/door/deviceauth/getByDeviceIdOrAreaId', Object.assign({}, options, { params }));
